// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Countdown__countdown__NfN2Q"};